import { IncidentCommunication } from "./IncidentCommunication";

export default IncidentCommunication;
